import * as yup from 'yup';

export const problemSchema = yup.object({
    stationId: yup.number().required('Trạm is required'),
    description: yup.string().nullable(),
    problemType: yup.number().required('Loại vấn đề is required').default(null),
    start: yup.string().required('Ngày bắt đầu is required'),
    end: yup.string().nullable(),
    status: yup.number().required('Trạng thái is required').default(null),
    files : yup.array().of(yup.number()).default([]),
});                                                                                                                                         